import { getScreenSize, useScreenSize } from './screenSize';

const screenMatchPattern = {
  mobile: ({ width }) => width <= 1024,
  desktop: ({ width }) => width > 1024,
};

export const getScreenMatch = (type: keyof typeof screenMatchPattern) => {
  const screenSize = getScreenSize();
  return screenMatchPattern[type](screenSize);
};

export const useScreenMatch = (type: keyof typeof screenMatchPattern) => {
  const screenSize = useScreenSize();
  return screenMatchPattern[type](screenSize);
};
